export const FETCH_USERSLIST_REQUEST = "FETCH_USERSLIST_REQUEST";
export const FETCH_USERSLIST_SUCCESS = "FETCH_USERSLIST_SUCCESS";
export const FETCH_USERSLIST_FAILURE = "FETCH_USERSLIST_FAILURE";
